import { render, staticRenderFns } from "./smeReferInformation.vue?vue&type=template&id=4b861a85&scoped=true&"
import script from "./smeReferInformation.vue?vue&type=script&lang=js&"
export * from "./smeReferInformation.vue?vue&type=script&lang=js&"
import style0 from "./smeReferInformation.vue?vue&type=style&index=0&id=4b861a85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b861a85",
  null
  
)

export default component.exports